import { createSlice } from '@reduxjs/toolkit'

import { setApiError } from 'src/Hooks/redux'

import { ApiError, NameSpace } from '../types'

import {
  AutoselectedGenre,
  getAutoselectedSpotifyPlaylistGenres,
} from './api-actions'

export interface GenresState {
  autoselectedGenres: AutoselectedGenre[]
  loading: boolean
  error: ApiError | null
}

const initialState: GenresState = {
  autoselectedGenres: [],
  loading: false,
  error: null,
}

export const genresProcess = createSlice({
  initialState,
  name: NameSpace.Genres,
  reducers: {},
  extraReducers(builder) {
    // getAutoselectedSpotifyPlaylistGenres
    builder.addCase(getAutoselectedSpotifyPlaylistGenres.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(
      getAutoselectedSpotifyPlaylistGenres.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action) || null
      },
    )
    builder.addCase(
      getAutoselectedSpotifyPlaylistGenres.fulfilled,
      (state, action) => {
        state.loading = false
        state.autoselectedGenres = action.payload
        state.error = null
      },
    )
  },
})
